import { REPORTS_DEFAULT_FILTERS } from '@constants/Reports/reportsDefaultToolbar.constants'

export const SCHEDULED_APPOINTMENTS_FILTERS = REPORTS_DEFAULT_FILTERS

export const SCHEDULED_APPOINTMENTS_KPI_DEFINITIONS: Array<{
  id: string
  title: string
  footer: string
  format: 'number' | 'decimal'
}> = [
  {
    id: 'patients-seen',
    title: 'Patients Seen',
    footer: 'Sum of filled slots',
    format: 'number',
  },
  {
    id: 'avg-filled-slots',
    title: 'Avg. Filled Slots',
    footer: 'Per day',
    format: 'decimal',
  },
  {
    id: 'avg-open-slots',
    title: 'Avg. Open Slots',
    footer: 'Per day',
    format: 'decimal',
  },
  {
    id: 'avg-hygiene-gaps',
    title: 'Avg. Hygiene Gaps',
    footer: 'Per day',
    format: 'decimal',
  },
  {
    id: 'no-shows',
    title: 'No-shows',
    footer: 'Total',
    format: 'number',
  },
]

/** @deprecated Use SCHEDULED_APPOINTMENTS_KPI_DEFINITIONS with live API values */
export const SCHEDULED_APPOINTMENTS_KPI_METRICS =
  SCHEDULED_APPOINTMENTS_KPI_DEFINITIONS.map((def) => ({
    id: def.id,
    title: def.title,
    footer: def.footer,
    value: '—',
  }))

export type FilledOpenSlotsRow = {
  month: string
  filled: number
  open: number
}

/** @deprecated Preview/PDF mock only */
export const FILLED_OPEN_SLOTS_DATA: FilledOpenSlotsRow[] = [
  { month: 'Dec', filled: 77.9, open: 18.9 },
  { month: 'Jan', filled: 77.2, open: 16.7 },
  { month: 'Feb', filled: 78, open: 17.9 },
  { month: 'Mar', filled: 81, open: 18.6 },
]

export type HygieneGapsRow = {
  month: string
  gaps: number
}

/** @deprecated Preview/PDF mock only */
export const HYGIENE_GAPS_DATA: HygieneGapsRow[] = [
  { month: 'Dec', gaps: 6.2 },
  { month: 'Jan', gaps: 5.7 },
  { month: 'Feb', gaps: 6.0 },
  { month: 'Mar', gaps: 6.0 },
]

export type ProductionTargetScheduledRow = {
  month: string
  /** Scheduled production in dollars. */
  scheduled: number
  /** Production target in dollars. */
  target: number
}

/** @deprecated Preview/PDF mock only */
export const PRODUCTION_TARGET_SCHEDULED_DATA: ProductionTargetScheduledRow[] =
  [
    { month: 'Dec', scheduled: 976_000, target: 1_170_000 },
    { month: 'Jan', scheduled: 1_050_000, target: 1_300_000 },
    { month: 'Feb', scheduled: 1_090_000, target: 1_170_000 },
    { month: 'Mar', scheduled: 179_000, target: 210_000 },
  ]

export type NoShowsRow = {
  month: string
  count: number
}

/** @deprecated Preview/PDF mock only */
export const NO_SHOWS_TREND_DATA: NoShowsRow[] = [
  { month: 'Dec', count: 124 },
  { month: 'Jan', count: 112 },
  { month: 'Feb', count: 91 },
  { month: 'Mar', count: 22 },
]
